/* ============
 * State of the account module
 * ============
 *
 * The initial state of the account module.
 */

export default {
    dharmams: [
        /* Activity */
        {
            id: 1,
            name: 'gosala',
            title: 'Gosamrakshanam'
        },
        {
            id: 2,
            name: 'veda-patasala',
            title: 'Veda Patasala'
        },
        {
            id: 3,
            name: 'annadhanam',
            title: 'Annadhanam',
        },
        {
            id: 4,
            name: 'others',
            title: 'Others'
        },

        /* Utsavam */
        {
            id: 5,
            name: 'brahmotsavam',
            title: 'Brahmotsavam',
        },
        {
            id: 6,
            name: 'jayanthi-utsavam',
            title: 'Sri Sri Jayanthi Utsavam',
        },

        /* Trust */
        {
            id: 7,
            name: 'srisrijayanthi',
            title: 'Sri Krishnapremi Swamigal 80th Jayanth Utsav Committee'
        },
        {
            id: 8,
            name: 'srimadhuri',
            title: 'Sri Madhuri Kalyana Mandapa Thiruppani Committee'
        },
        {
            id: 9,
            name: 'brahma-sabha',
            title: 'Brahma Sabha Trust',
        }
    ]
};


// WEBPACK FOOTER //
// ./src/store/modules/dharmams/state.js